import { render, staticRenderFns } from "./HPModelEditDetails.vue?vue&type=template&id=680f1754&scoped=true"
import script from "./HPModelEditDetails.vue?vue&type=script&lang=js"
export * from "./HPModelEditDetails.vue?vue&type=script&lang=js"
import style0 from "./HPModelEditDetails.vue?vue&type=style&index=0&id=680f1754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f1754",
  null
  
)

export default component.exports